import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import { HintField, LabelField } from 'components';
import { getDateFormatForDatePicket, getDateTimeFormatForDatePicket } from 'helper/dateFormat';
import React, { memo, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import './DateStyle.scss';
import { fontConfig } from "theme/fontConfig";

const CustomInput = React.forwardRef(({ value, onClick, onChange, onBlur, pipe, mask, keepCharPositions, guide, ...rest }, ref) => {
  return (
    <MaskedInput
      ref={ref}
      {...rest}
      value={value}
      onClick={onClick}
      onChange={onChange}
      onBlur={onBlur}
      pipe={pipe}
      mask={mask}
      keepCharPositions={keepCharPositions}
      guide={guide}
    />
  );
});

export const DateTimePickerField = ({
  myStyle,
  memberInfo,
  title,
  name,
  style,
  type,
  rules,
  error,
  formik,
  checkValidation = false,
  mandatory = false,
  alwaysAvailable = false,
  checkAvailableHandler,
  action,
  index,
  handleChange,
  value,
  minDate,
  maxDate,
  minTime = null,
  maxTime = null,
  filterTime,
  disabled,
  onChange,
  selected,
  showTimeSelect,
  dateFormat,
  placeholderText,
  mask,
  ...rest
}) => {
  const dateRef = useRef(null);
  const getInputClasses = () => {
    if (!checkValidation) {
      return '';
    }
    if (formik.touched[name] && formik.errors[name]) {
      return 'is-invalid';
    }

    if (formik.touched[name] && !formik.errors[name]) {
      return 'is-valid';
    }

    return '';
  };
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(getDateFormatForDatePicket() || 'mm/dd/yyyy');

  return (
    <div
      className={
        memberInfo
          ? 'form-group fv-plugins-icon-container datepicker-caontainer member-info-date'
          : 'form-group fv-plugins-icon-container datepicker-caontainer'
      }
    >
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ height: '27px' }}
      >
        <div className="d-flex">
          <LabelField
            htmlFor={name}
            title={title}
            className={memberInfo ? 'member-info-date-lable' : ''}
            style={{
              fontFamily: fontConfig.GeneralMemberInfoDateLableFont.family,
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              color: '#4F4F4F',
            }}
          />
          {mandatory && (
            <label style={{ fontWeight: '500', color: 'red' }} {...rest}>
              {' *'}
            </label>
          )}
        </div>
        {alwaysAvailable && (
          <div className="col-sm-6 d-flex justify-content-end align-items-center p-0 mb-2">
            <div className="col d-flex justify-content-end text-nowrap">
              Always Available
            </div>
            <FormControlLabel
              control={
                <Switch
                  checked={formik.values?.alwaysAvailable}
                  onChange={checkAvailableHandler}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              }
              style={{ margin: '0px' }}
            />
          </div>
        )}
      </div>
      <div className={memberInfo ? 'd-flex member-info-date-input' : 'd-flex'}>
        {/* <input
            ref={dateRef}
            id="datetime-local"
            label=""
            // type="datetime-local"
            type="date"
            defaultValue=""
            className={`form-control form-control-solid h-auto py-4 pl-2 common-data-picker ${getInputClasses()}`}
            {...rest}
            {...formik.getFieldProps(name)}
            InputLabelProps={{
              shrink: true,
            }}
            value={action === "class_discount" ? formik.values?.discount?.[index][name]: value || null}
            style={myStyle}
            onChange={handleChange}
          /> */}

        <DatePicker
          showTimeSelect={showTimeSelect || false}
          isClearable
          showIcon
          dateFormat={dateFormat || "MM/dd/yyyy"}
          placeholderText={placeholderText || "MM/DD/YYYY"}
          selected={selected}
          onChange={onChange}
          onBlur={() => formik?.handleBlur(name)}
          onCalendarClose={() => formik?.handleBlur(name)}
          minDate={minDate}
          maxDate={maxDate}
          minTime={minTime}
          maxTime={maxTime}
          filterTime={filterTime}
          disabled={disabled}
          customInput={
            <CustomInput
              className={`form-control form-control-solid ${getInputClasses()}`}
              pipe={autoCorrectedDatePipe}
              mask={mask || [
                /\d/,
                /\d/,
                '/',
                /\d/,
                /\d/,
                '/',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              keepCharPositions={true}
              guide={true}
              onBlur={() => formik?.handleBlur(name)}
            />
          }
        />
      </div>
      {error !== undefined
        ? (error ? <HintField error={error} /> : null)
        : (formik.touched[name] && formik.errors[name] ? <HintField error={formik.errors[name]} /> : null)
      }
    </div>
  );
};
